/**
 * Appends an optional display suffix to a multi-select result row's label —
 * "Hvid hussvamp" + "spp" → "Hvid hussvamp spp" (MIL-395).
 *
 * Display only: the suffix never affects validation, ordering, colouring, QA,
 * or how a row is matched. An unresolvable suffix (missing, archived away, or
 * belonging to another lab) yields the bare label rather than an id or a
 * stray separator, so a stale reference degrades quietly on the report instead
 * of printing something meaningless.
 *
 * Deliberately duplicated in lab-cloud's own resolveOrderResultsForReport.ts —
 * the two report resolvers are already twins, and there is no shared module
 * between the frontend and the functions codebase to put this in.
 */
export function withResultSuffix(label: string, suffix: string): string {
  const trimmed = suffix.trim()
  if (!label || !trimmed) return label
  return `${label} ${trimmed}`
}
